// extracted by mini-css-extract-plugin
module.exports = {"Name":"Map_Name__3VTiO"};